// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header__text-lWoqQ";
var _4 = "message__text-1yR4m";
var _5 = "modal-fWNDA";
export { _1 as "__esModule", _2 as "mobile", _3 as "header__text", _4 as "message__text", _5 as "modal" }
export default { "__esModule": _1, "mobile": _2, "header__text": _3, "message__text": _4, "modal": _5 }
